"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var form_1 = require("../../ui/form");
var utils_1 = require("../../crud-simple/pre/utils");
var FormUI = function (fields, onCancel, submitLabel) { return function (props) {
    var onSubmit = props.onSubmit, onChange = props.onChange, data = props.data, errors = props.errors;
    return (react_1["default"].createElement(form_1.FormLayout, { onSubmit: onSubmit, submitLabel: submitLabel, onCancel: onCancel }, fields.map(function (f, i) {
        var myOnChange = onChange;
        if (f.onChange) {
            myOnChange = function (changedField) {
                if (f.onChange) {
                    f.onChange(changedField);
                }
                onChange(changedField);
            };
        }
        return (react_1["default"].createElement(form_1.Wrapper, { key: i, label: f.label, name: f.name, errors: errors, type: utils_1.mapTypes(f), mandatory: f.mandatory },
            react_1["default"].createElement(form_1.InputGeneric, { field: f, data: data, onChange: myOnChange })));
    })));
}; };
exports["default"] = FormUI;
